import {Dispatch, SetStateAction} from "react";
import {DashboardSettingSearchParamType} from "../../detail/interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {SubmitHandler, useForm} from "react-hook-form";
import {useUpdateInitialDashboardSetting} from "../hooks/useUpdateInitialDashboardSetting";
import {useModal} from "../../../../../hooks";

interface PropsType {
    searchParam: DashboardSettingSearchParamType
    setSearchParam: Dispatch<SetStateAction<DashboardSettingSearchParamType>>
    selectedItem: number[]
    setSelectedItem: Dispatch<SetStateAction<number[]>>
}

export default function Filter({searchParam, setSearchParam, selectedItem, setSelectedItem}: PropsType) {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();

    const closeCallback = () => setSelectedItem([])
    const {mutate: mutateUpdateInitialDashboardSetting} = useUpdateInitialDashboardSetting({closeCallback: closeCallback})

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<DashboardSettingSearchParamType> = (submitData) => {
        goToNavigation(`main/dashboard/edit?pageNo=1`, {}, false)
        setSearchParam({...submitData, pageNo: 1});
    };

    const onClickCheck = (str: "Y" | "N") => {
        if (getValues("deleteFlagList").includes(str)) {
            setValue("deleteFlagList", getValues("deleteFlagList").filter(el => el !== str))
        } else {
            setValue("deleteFlagList", [...getValues("deleteFlagList"), str])
        }
    }

    const btnReset = () => {
        handleModal({
            isOpen: true,
            contents: "초기화 하시겠습니까?",
            type: "confirm",
            callback: () => mutateUpdateInitialDashboardSetting()
        })
    }

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">대시보드 구성 검색</h3>
            <div className="filter_toolbar">
                <button className="btn btn-primary w-130px px-0" onClick={btnReset}>대시보드 초기화</button>
            </div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <div className="frm_field">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="inlineRadioOptions"
                                   id="inlineRadio1" checked={watch("deleteFlagList").includes("Y")}
                                   onClick={() => onClickCheck("Y")}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">활성</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="inlineRadioOptions"
                                   id="inlineRadio2" checked={watch("deleteFlagList").includes("N")}
                                   onClick={() => onClickCheck("N")}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">비활성</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row search">
                    <select className="form-select" value={watch("keywordType")} {...register("keywordType")}>
                        <option value="0">레포트명</option>
                    </select>
                    <input type="text" className="form-control me-0" value={watch("keyword")} {...register("keyword")}/>
                    <button className="btn btn-info btn_search">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>
            </div>
        </form>
    </div>
}